import {createSlice} from "@reduxjs/toolkit";
import {
  loadSearchMetaData,
  clearRecentDrugSearchesThunk,
  drugSearchThunk,
  combinedSearchThunk, saveSearchThunk,
} from './thunks';

const searchMetadataSlice = createSlice({
  name: 'searchMetadataSlice',
  initialState: {
    recentSearches: {
      combinedSearches: [],
      drugSearches: [],
    },
    savedSearches: {},
    currentSearchText: '',
    currentSearchMatchesSavedSearch: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(drugSearchThunk.fulfilled, (state, action) => {
        state.recentSearches = {
          ...action.payload.recentSearches,
        };
      })
      .addCase(combinedSearchThunk.pending, (state, action) => {
        const searchText = action.meta?.arg?.searchText;
        state.currentSearchText = searchText;
        state.currentSearchMatchesSavedSearch = state.savedSearches?.[searchText] || false;
      })
      .addCase(combinedSearchThunk.fulfilled, (state, action) => {
        state.recentSearches = {
          ...action.payload.recentSearches,
        };
      })
      .addCase(loadSearchMetaData.fulfilled, (state, action) => {
        state.recentSearches = {
          ...state.recentSearches,
          drugSearches: action.payload?.recentSearches?.drugSearches,
          combinedSearches: action.payload?.recentSearches?.combinedSearches,
        };
        state.savedSearches = {
          ...action.payload?.savedSearches,
        };
        state.currentSearchMatchesSavedSearch = state.savedSearches?.hasOwnProperty(state.currentSearchText) || false;
      })
      .addCase(clearRecentDrugSearchesThunk.fulfilled, (state, action) => {
        state.recentSearches = {
          ...state.recentSearches,
          ...action.payload,
        };
      })
      .addCase(saveSearchThunk.fulfilled, (state, action) => {
        state.savedSearches = {
          ...action.payload,
        }
        state.currentSearchMatchesSavedSearch = action.payload?.hasOwnProperty(state.currentSearchText) || false;
      });
  },
});

export default searchMetadataSlice.reducer;

export const selectRecentSearches = (state) =>
  state.searchMetadataSlice?.recentSearches;
export const selectSavedSearches = (state) => state.searchMetadataSlice?.savedSearches
export const selectIfSearchMatchesSavedSearch = (state) => state.searchMetadataSlice?.currentSearchMatchesSavedSearch;